"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClassNames = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var config_context_1 = require("../../_util/config-context");
var _classnames_1 = require("../../_classnames");
function replace(current, prefix) {
    if (typeof current === "object") {
        Object.entries(current).forEach(function (_a) {
            var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
            if (typeof value === "object") {
                current[key] = replace(value, prefix);
            }
            if (typeof value === "string") {
                current[key] = value.replace(/^tea-/, prefix + "-");
            }
        });
    }
    return current;
}
function useClassNames() {
    var classPrefix = config_context_1.useConfig().classPrefix;
    var classNames = react_1.useMemo(function () { return replace(_classnames_1.TeaClassNames, classPrefix); }, [classPrefix]);
    return classNames;
}
exports.useClassNames = useClassNames;
//# sourceMappingURL=useClassNames.js.map